import { Options } from 'highcharts';
import { crosshair } from '../components/common';
import { ChartType } from '../components/types';
import {
  getDefaultChartOptions,
  getDefaultScrollBarOptions,
  getDefaultTooltipOptions,
  getLegendOptions,
} from './utils';

export const getCustomChartOptions = (initialOptions?: Options): Options => {
  const chartType =
    initialOptions?.chart?.type === ChartType.Line
      ? ChartType.Spline
      : initialOptions?.chart?.type;

  return {
    ...initialOptions,
    chart: {
      ...getDefaultChartOptions(),
      ...initialOptions?.chart,
      type: chartType,
      zoomType: 'xy',
      panKey: 'shift',
    },
    ...(initialOptions?.colors && { colors: initialOptions?.colors }),
    tooltip: {
      ...getDefaultTooltipOptions(),
      ...initialOptions?.tooltip,
    },
    plotOptions: {
      ...initialOptions?.plotOptions,
      column: {
        ...initialOptions?.plotOptions?.column,
        stacking: 'normal',
      },
      series: {
        ...initialOptions?.plotOptions?.series,
        dataSorting: {
          enabled: true,
          sortKey: 'val',
        },
        connectNulls: true,
      },
    },
    title: initialOptions?.title,
    xAxis: {
      type: 'category',
      ...initialOptions?.xAxis,
      title: {
        text: (initialOptions?.xAxis as any)?.title,
      },
      ...(chartType === ChartType.Spline && { crosshair }),
    },
    yAxis: {
      ...initialOptions?.yAxis,
      title: {
        text: (initialOptions?.yAxis as any)?.title,
      },
    },
    scrollbar: {
      ...initialOptions?.scrollbar,
      ...getDefaultScrollBarOptions(),
    },
    legend: {
      ...initialOptions?.legend,
      ...(initialOptions?.legend?.enabled && getLegendOptions()),
    },
  };
};
